// ImageInfo.jsx
// Displays image metadata and rotation information in the viewer.

// Copyright HS Analysis GmbH, 2019
// Author: Sebastian Murgul, Viktor Eberhardt

// Framework imports
import React from "react";
import PropTypes from "prop-types";

// MUI imports
import { Typography } from "@mui/material";
import withStyles from "@mui/styles/withStyles";

// Icon imports
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const styles = {
  root: {
    pointerEvents: "none",
    width: "auto",
    maxWidth: "600px",
    height: "auto",

    position: "absolute",
    top: 10,
    left: 5,
    color: "#ffffff",

    padding: 0,
    "& :active": {
      outline: "",
    },
    background: "#000000AA",
    border: "2px solid rgb(85, 85, 85)",
    borderRadius: 10,
    zIndex: 9999,
  },
  barIcon: {
    position: "absolute",
    top: -1,
    left: 2,
    height: 42,
    width: "36px!important",
    padding: 8,
    color: "#ffffff",
  },
  infoArea: {
    paddingLeft: "40px",
    paddingRight: "10px",
    right: 0,
    top: 0,
    bottom: 0,
    color: "#fff",
  },
};

const ImageInfo = ({ classes, ome, rotState }) => {
  const rotationDegree = React.useMemo(() => {
    let rotation = ome ? ome.angle : 0;
    if (typeof rotState === "undefined" || rotState === 0)
      return rotation % 360;
    rotation += rotState;
    return rotation % 360;
  }, [rotState, ome]);

  return (
    <div className={classes.root}>
      <FontAwesomeIcon className={classes.barIcon} icon={faInfo} />
      {ome && (
        <div className={classes.infoArea}>
          <Typography color="inherit" noWrap={true}>
            {ome.fileName}{" "}
            {ome.sizeS > 1 && <span>, Scene {ome.scene + 1}</span>}
          </Typography>
          <Typography color="inherit" noWrap={true} style={{ fontSize: 12 }}>
            Size: {ome.sizeX}x{ome.sizeY}
          </Typography>
          {rotationDegree !== 0 && (
            <Typography color="inherit" noWrap={true} style={{ fontSize: 12 }}>
              Rotation: {rotationDegree}°{" "}
              {rotState && rotState !== 0 && ome.angle !== 0 && (
                <span>
                  ({ome.angle}° + {rotState})
                </span>
              )}
            </Typography>
          )}
        </div>
      )}
    </div>
  );
};

ImageInfo.propTypes = {
  classes: PropTypes.object.isRequired,
  ome: PropTypes.object,
  rotState: PropTypes.number,
};

export default withStyles(styles)(ImageInfo);
